export const minLengthPassword = 6
export const userPhoneLength = 11
export const maxLengthField = 255
